module.exports = __webpack_public_path__ + "static/img/4.ccd2671.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner2/4.png
// module id = PjRb
// module chunks = 14